import { WatchLater } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { DynamicTooltip } from './DynamicTooltip';

export const SupplierVerifyingTooltip = () => {
    const { t } = useTranslation();
    return (
        <DynamicTooltip
            content={
                <div>
                    <Typography
                        variant="subtitle2"
                        sx={{
                            fontWeight: '600',
                            color: '#FF9900',
                            marginBottom: '8px',
                        }}
                    >
                        {t('Pending')}
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            lineHeight: '1.4',
                        }}
                    >
                        {t(
                            'Supplier is in the process of enabling your account.',
                        )}
                        <br />
                        {t('Your account must be enabled to submit orders.')}
                    </Typography>
                </div>
            }
        >
            <WatchLater
                sx={{
                    color: '#FF9900',
                    fontSize: '15px',
                    marginTop: '4px',
                }}
            />
        </DynamicTooltip>
    );
};
